import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from "react";
import { block } from "../../../core/react";

var maxBy = require("lodash/maxBy");

var map = require("lodash/map");

function computeMaxValue(items, field) {
  if (!items || items.length == 0) return 0;
  return maxBy(items, field)[field];
}

export var RangeHistogram =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(RangeHistogram, _React$PureComponent);

  function RangeHistogram() {
    _classCallCheck(this, RangeHistogram);

    return _possibleConstructorReturn(this, _getPrototypeOf(RangeHistogram).apply(this, arguments));
  }

  _createClass(RangeHistogram, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          mod = _this$props.mod,
          className = _this$props.className,
          minValue = _this$props.minValue,
          maxValue = _this$props.maxValue,
          _this$props$items = _this$props.items,
          items = _this$props$items === void 0 ? [] : _this$props$items;
      var bemBlocks = {
        container: block(mod).el
      };
      var maxCount = computeMaxValue(items, "doc_count");
      if (maxCount == 0) return null;
      var bars = map(items, function (_ref) {
        var key = _ref.key,
            doc_count = _ref.doc_count;
        var outOfBounds = key < minValue || key > maxValue;
        return React.createElement("div", {
          className: bemBlocks.container('bar').state({
            'out-of-bounds': outOfBounds
          }),
          key: key,
          style: {
            height: "".concat(doc_count / maxCount * 100, "%")
          }
        });
      });
      return React.createElement("div", {
        className: bemBlocks.container().mix(className)
      }, bars);
    }
  }]);

  return RangeHistogram;
}(React.PureComponent);
RangeHistogram.defaultProps = {
  mod: 'sk-range-histogram'
};